import { useNavigate } from "react-router";
import { RoutesPaths } from "../../../Router/constant";

export default function ChatSideBar({
  isActivationBusinessChat = false,
  isActivationPartnerChat = false,
  isLoading = false,
}) {

  const navigate = useNavigate()

  const renderSidebarSkeleton = () => (
    <div className="sidebarContent chatSidebarSkeleton" aria-hidden="true">
      <div className="chatSidebarSkeletonTitle" />
      <div className="chatSidebarSkeletonIntro">
        <span />
        <span />
      </div>

      {[1, 2, 3, 4].map((item) => (
        <div className="chatSidebarSkeletonCard" key={item}>
          <div className="chatSidebarSkeletonCardLabel" />
          <div className="chatSidebarSkeletonCardTitle" />
          <div className="chatSidebarSkeletonCardLine" />
          <div className="chatSidebarSkeletonCardLine short" />
        </div>
      ))}
    </div>
  )

  return (
    <>
      <div onClick={() => navigate(RoutesPaths.HOME)} className="userListSidebarHeader">
        <img src="assets/img/inproved-logo.svg" alt="" srcset="" />
      </div>
      <div className={`userListSidebarHolder ${isActivationBusinessChat || isActivationPartnerChat ? "activationSidebarHolder" : ""}`}>
        {isLoading ? renderSidebarSkeleton() : isActivationPartnerChat ? (
          <div className="sidebarContent activationSidebarContent">
            <h5>One link. We track the rest.</h5>
            <p className="activationSidebarIntro">Three short steps and your partner account is live.</p>

            <div className="activationSidebarCard">
              <span>STEP 1</span>
              <h6>Your profile</h6>
              <p>Who you are and where you work. About two minutes.</p>
            </div>

            <div className="activationSidebarCard">
              <span>STEP 2</span>
              <h6>Who you refer</h6>
              <p>The clients you meet and what they usually need. This decides which clients and campaigns we match you with.</p>
            </div>

            <div className="activationSidebarCard">
              <span>STEP 3</span>
              <h6>Review and activate</h6>
              <p>Check your profile, then switch it on. Your referral link is ready in the app straight after.</p>
            </div>

            <p className="activationSidebarFooter">
              No cost to join, no quota. Payouts follow the Advisor Terms and Conditions.
            </p>
          </div>
        ) : isActivationBusinessChat ? (
          <div className="sidebarContent activationSidebarContent">
            <h5>Two ways to start.</h5>
            <p className="activationSidebarIntro">One tells you whether it will work. The other builds it.</p>

            <div className="activationSidebarCard">
              <span>Feasibility</span>
              <h6>Know before you spend.</h6>
              <p>
                We test your business against real banks and real rules, then tell you straight — who will bank you, what licence you need, what it costs to run. Nothing is formed yet.
              </p>
            </div>

            <div className="activationSidebarCard">
              <span>Full activation</span>
              <h6>Start operating.</h6>
              <p>
                Your Singapore company, a named resident director, and a business account. Until these exist, no bank will open and no counterparty will sign.
              </p>
            </div>

            <p className="activationSidebarFooter">
              Either way, you deal with us directly. <strong>Our resident director is a real person who reviews your filings and sits in your banking relationship</strong> — not a name rented out to sit on a form.
            </p>
          </div>
        ) : (
          <div className="sidebarContent">
            <h5>kimbocorp: Build Smarter, Not Harder</h5>
            <p>Set up your Singapore business the right way — before you even incorporate </p>
            <p className="mt-4">✅ What you gain:</p>
            <ul>
              <li><p>Scope out your business before committing</p></li>
              <li><p>Access world-class tax, banking, and legal efficiencies</p></li>
              <li><p>Invite real advisors and shareholders to join early</p></li>
              <li><p>Use professional-grade tools to save time, money, and mistakes</p></li>
              <li><p>Enjoy better odds of success — your business is built to operate</p></li>
            </ul>
            <p className="mt-4">⚠️ What you risk by waiting: </p>
            <ul>
              <li><p>Missed banking approvals, tax savings, or license windows</p></li>
              <li><p>Onboarding co-founders too late or too informally</p></li>
              <li><p>Paying full fees for rushed incorporations that don’t scale</p></li>
              <li><p>Losing investor confidence from unclear structure or governance</p></li>
            </ul>
            <p className="mt-4">✅ Ready to build a serious business in Singapore? Start here, and we’ll guide you. </p>
          </div>
        )}
      </div>
    </>

  );
}
